import { defineStore } from "pinia";
import { ref } from "vue";
import GdvAccess from "@/shared/model/GdvAccess";

export const useGdvStore = defineStore("gdv", () => {
  const gdvAccess = ref<GdvAccess | undefined>(undefined);

  return { gdvAccess};
});
